<template>
  <page layout="tabbed">
    <page-header :title="pageTitle" :breadcrumbs="breadcrumbs">
      <slot name="actions" slot="actions" />
    </page-header>

    <page-tabs :tabs="enabledTabs">
      <slot slot="router" />
    </page-tabs>
  </page>
</template>

<script>
import Page from '@/common/components/page/Page'
import PageHeader from '@/common/components/page/PageHeaderNew'
import PageTabs from '@/common/components/page/PageTabs'
import { projectRoute } from '@/core/helpers'
import { $hasFeature } from '../../../core/utils/VueAcl'

export default {
  name: 'DataManagerLayout',

  components: {
    Page,
    PageHeader,
    PageTabs
  },

  computed: {
    pageTitle() {
      return this.$t('DataManager_Title')
    },

    projectId() {
      return this.$route.query.project_id
    },

    breadcrumbs() {
      return [
        {
          label: this.$t('DataManager_Breadcrumb_Data')
        },
        {
          label: this.$t('DataManager_Breadcrumb_DataManager')
        }
      ]
    },

    tabs() {
      return [
        {
          title: this.$t('DataManager_Tab_AttributesTags'),
          route: projectRoute({
            name: 'DataManagerAttributesTags',
            query: {
              project_id: this.projectId
            }
          })
        },
        {
          title: this.$t('DataManager_Tab_TagCategories'),
          route: projectRoute({
            name: 'DataManagerTagCategories',
            query: {
              project_id: this.projectId
            }
          }),
          enabled: () => {
            return $hasFeature('tagCategories')
          }
        },
        {
          title: this.$t('DataManager_Tab_Aggregates'),
          route: projectRoute({
            name: 'DataManagerAggregates',
            query: {
              project_id: this.projectId
            }
          }),
          enabled: () => {
            return $hasFeature('aggregatesEnabled') || $hasFeature('mlStudio')
          }
        },
        {
          title: this.$t('DataManager_Tab_Events'),
          route: projectRoute({
            name: 'DataManagerEvents',
            query: {
              project_id: this.projectId
            }
          })
        },
        {
          title: this.$t('DataManager_Tab_Metrics'),
          route: projectRoute({
            name: 'DataManagerMetrics',
            query: {
              project_id: this.projectId
            }
          })
        },
        {
          title: this.$t('DataManager_Tab_Locations'),
          route: projectRoute({
            name: 'DataManagerLocations',
            query: {
              project_id: this.projectId
            }
          })
        }
      ]
    },

    enabledTabs() {
      return this.tabs.filter(item => {
        if (item.enabled === undefined) {
          return true
        } else {
          return item.enabled()
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/data-manager/pages/DataManagerLayout.vue